<template>
  <md-empty-state v-bind="$props" class="md-table-empty-state">
    <slot />
  </md-empty-state>
</template>

<script>
import MdEmptyState from '../MdEmptyState/MdEmptyState';
import MdEmptyStateProps from '../MdEmptyState/MdEmptyStateProps';

export default {
  name: 'MdTableEmptyState',
  inject: ['MdTable'],
  props: MdEmptyStateProps,
};
</script>

<style lang="scss">
@import '../MdAnimation/variables';

.md-table-empty-state {
  padding-left: 24px;
}
</style>
